import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { find } from 'lodash';
import { Modal } from 'antd';
import { Badge } from '../../components/Circle';
import { ColumnTitle } from '../../components/ColumnTitle';
import { Flex } from '../../components/Flex';
import { Table } from '../../components/AntdTable';
import { Title } from '../../components/Text';
import { CircleIcon } from '../../icons/CircleIcon';
import { CloseIcon } from '../../icons/CloseIcon';
import { removeNotification } from '../../store/notificationsSlice';
import { Notification } from './Notification';

const errorList = {
    413: "The file is too big. Please upload a smaller file or contact VSI support.",
    500: "Internal server error. Please contact VSI support."
};

const NotificationContainer = () => {
    const dispatch = useDispatch();
    const { notifications } = useSelector(state => state.notifications);

    const [ state, setState ] = useState({
        visible: false,
        log: []
    });

    useEffect(() => {
        const interval = setInterval(() => {
            if (notifications.length) {
                if (notifications[0].closable) dispatch(removeNotification(notifications[0].id));
            }
        }, 3000);

        return () => clearInterval(interval);
    }, [ notifications.length ]);

    const columns = [
        {
            title: ({ sortOrder, sortColumn }) => ColumnTitle(sortOrder, sortColumn, "status", <CircleIcon />),            dataIndex: 'status',
            render: (text, record, index) =>
                <>
                    {text == 200 || text == 201 ? <Badge color="#55C36D" /> : text == 404 ? <Badge color="var(--sp-error-hover-color)" /> : <Badge color="#ECA564" />}
                </>,
            width: 56,
            sorter: (a, b) => { if (a && a.hasOwnProperty("status") && a.status) return a.status - b.status }
        },
        {
            title: ({ sortOrder, sortColumn }) => ColumnTitle(sortOrder, sortColumn, "orgAlias", "Organization alias"),
            dataIndex: 'orgAlias',
            width: 180,
            sorter: (a, b) => { if (a && a.hasOwnProperty("orgAlias") && a.orgAlias) return a.orgAlias.localeCompare(b.orgAlias) }
        },
        {
            title: ({ sortOrder, sortColumn }) => ColumnTitle(sortOrder, sortColumn, "message", "Result"),
            dataIndex: 'message',
            sorter: (a, b) => { if (a && a.hasOwnProperty("message") && a.message) return a.message.localeCompare(b.message) }
        }
    ];

    const showLog = (id) => {
        let notification = find(notifications, { id: id });
        if (notification && notification.log) {
            setState({ visible: true, log: notification.log })
        };
        dispatch(removeNotification(id));
    };

    const hideNotification = (id) => {
        dispatch(removeNotification(id));
    };

    return(
        <>
            {notifications.length
                ? notifications.map(notification =>
                        <Notification
                            key={notification.id}
                            type={notification.type || "info"}
                            code={notification.code}
                            notificationId={notification.id}
                            message={notification.code && errorList.hasOwnProperty(notification.code) ? errorList[notification.code] : notification.message}
                            hideMsg={hideNotification}
                            log={notification.log && notification.log.length > 0}
                            showLog={showLog}
                        />
                    )
                : null}
            {state.visible
                ? <Modal
                    centered
                    width={600}
                    className="sp-modal"
                    visible={state.visible}
                    closeIcon={<CloseIcon />}
                    footer={<span />}
                    onCancel={() => setState({ visible: false, log: [] })}
                    >
                        <Title h4 margin={{ bottom: "8px" }}>Results of uploading organisations contracts</Title>
                        <Flex height={state.log.length > 6 ? "calc(100vh - 330px)" : null}>
                            <Table
                                columns={columns}
                                dataSource={state.log}
                                loading={false}
                                pagination={false}
                                scroll={{ y: true }}
                                showSorterTooltip={false}
                            />
                        </Flex>
                </Modal>
                : null}
        </>
    )
};

export { NotificationContainer };